import { styled } from "styled-components"
import { Heading3, Heading4, T4_ko } from "../../../style/constant"
import { useRecoilValue } from "recoil"
import { langSelector, langState } from "../../../state/langState"

const News = () => {
	const currentLang = useRecoilValue(langState)
	const Text = useRecoilValue(langSelector)

	return(
		<Container>
			<Title>{Text.worldInTraum.title}</Title>
			
			<Wrapper>
				{
					Text.worldInTraum.news.map(item =>
					 <>
						<Article>
							<DateArea>
								<NewsText>{item.news}</NewsText>
								<Date>{item.date}</Date>
							</DateArea>
						</Article>	
						<NewsTitle>{item.newsTitle}</NewsTitle>
					</>
					)
				}

			</Wrapper>
			
		</Container>
	)
}


export default News

interface Props {
	currentLang:boolean;
}

const Container = styled.section`
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: black;
`

const Title = styled.h2`
	${T4_ko};
	margin-top:100px;
`

const Wrapper = styled.div`
	width:790px;
	margin:100px 0;
`

const Article = styled.div`
	border-top: 0.5px solid #2c2c2c;
	margin-bottom:10px;
	cursor: pointer;
`

const DateArea = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 8px 0 10px 0;	
`

const NewsText = styled.p`
	color:#276BFF;
`

const Date = styled.p`
    ${Heading4};
	opacity: 0.4;
`

const NewsTitle = styled.p`
	${Heading3}
	margin-bottom:50px;
`